import React from "react";
import { useTranslation } from "react-i18next";
import { LineChart, MonitorSmartphone, Layers, Globe2, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SECTION_IDS, useSectionNav } from "@/lib/navigation";

const ICONS = [LineChart, MonitorSmartphone, Layers, Globe2];

export const Benefits = () => {
  const { t } = useTranslation();
  const goToSection = useSectionNav();
  const items = t("benefits.items", { returnObjects: true }) || [];

  return (
    <section
      id={SECTION_IDS.why}
      className="border-b border-border bg-background"
      data-testid="home-benefits"
    >
      <div className="container-page py-16 sm:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <p className="eyebrow">{t("benefits.eyebrow")}</p>
            <h2 className="mt-4 text-2xl font-semibold leading-tight tracking-tight text-foreground sm:text-[34px]">
              {t("benefits.title")}
            </h2>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-muted-foreground sm:text-base">
              {t("benefits.lead")}
            </p>
            <Button
              type="button"
              variant="outline"
              onClick={() => goToSection(SECTION_IDS.contact)}
              className="mt-6 h-11 rounded-lg border-border bg-card px-5 text-sm"
              data-testid="benefits-cta"
            >
              {t("benefits.cta")}
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-7">
            {items.map((item, index) => {
              const Icon = ICONS[index % ICONS.length];
              const accent = index % 3 === 0;
              return (
                <article
                  key={item.title}
                  className={`rounded-xl border border-border bg-card p-5 transition-shadow hover:shadow-[0_10px_30px_hsl(214_30%_10%/0.09)] ${
                    accent ? "border-l-2 border-l-[hsl(var(--terracotta))]" : ""
                  }`}
                  data-testid={`benefit-card-${index}`}
                >
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-secondary">
                    <Icon className="h-5 w-5 text-[hsl(var(--deep-blue))]" />
                  </span>
                  <h3 className="mt-4 text-base font-semibold text-foreground">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                    {item.text}
                  </p>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
